import { AdminRootState } from 'store/types';

export const getLogo = (store: AdminRootState) => store.admin.logo;

export const getSignature = (store: AdminRootState) => store.admin.signature;
